import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, of } from "rxjs";
import { environment } from "../../environments/environment";
import { AuthenticationService } from "../../shared/services/authentication.service";
import { ITag } from "../model/tag.model";

@Injectable()
export class TagsService{
    Tags$!:Observable<ITag[]>;
    newTag$!:Observable<ITag>;
    createdTag!:ITag;

    private http = inject(HttpClient);
    authService = inject(AuthenticationService);
    
    getTags(): Observable<ITag[]> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.get<ITag[]>( environment.API_URL + '/api/Tag/', options);
        } else {
            return of();
        }    
    }  

    deleteTag(id: string): Observable<ITag> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.post<ITag>( environment.API_URL + `/api/Tag/delete/${id}`, {}, options);
        } else {
            return of();
        }    
    }   
    
    createTag(tag: ITag): Observable<ITag> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.post<ITag>( environment.API_URL + '/api/Tag/Create', tag, options);
        } else {
            return of();
        }    
    }

    editTag(tag: ITag): Observable<ITag> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.post<ITag>( environment.API_URL + '/api/Tag/', tag, options);
        } else {
            return of();
        }    
    }    
}
